import { useStore } from 'features/ListBuilder/infra/react/ListBuilderStore/useStore'

export const useDeleteListMembersState = () =>
  useStore(store => store.deleteListMembers.state)
